import React from 'react';
import { Box } from '@skin-seoul/design-system';

import { LoyaltyBannerDesktop } from './LoyaltyBanner.Desktop';
import { LoyaltyBannerMobile } from './LoyaltyBanner.Mobile';

interface LoyaltyBannerProps {
  points: number;
  memberSince?: string;
}

export const LoyaltyBanner = ({ points, memberSince }: LoyaltyBannerProps) => {
  return (
    <>
      {/* Mobile View - Below tablet breakpoint (768px) */}
      <Box hideFrom="tablet">
        <LoyaltyBannerMobile points={points} />
      </Box>

      {/* Desktop View - Above tablet breakpoint */}
      <Box hideBelow="tablet">
        <LoyaltyBannerDesktop points={points} memberSince={memberSince} />
      </Box>
    </>
  );
};
